<template>
  <div class="aiPage">
    <template v-if="from!='introDetail'">
      <Header />
      <Box1 />
    </template>
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6 />
    <Box7 />
    <Box8 />
    <Box9 />
    <Box10 />
    <Box11 />
    <div class="box12" id="box12"></div>
    <Box13 />
    <Box14 />
    <Box15 />
    <Box16 />
    <Box17 />
    <Box18 />
    <div class="box19">
      <div class="left-box">
        人工智能学习路线图
        <div class="left-btn" @click="goHref">免费领取</div>
      </div>
      <img
        class="box19-icon"
        src="../../../assets/coursePage/ai/box19-icon.png"
        alt
      />
    </div>
    <pageRightFloat pageName="人工智能开发-AI就业课"/>
    <Footer />
  </div>
</template>

<script>
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box3 from "./Box3.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import Box8 from "./Box8.vue";
import Box9 from "./Box9.vue";
import Box10 from "./Box10.vue";
import Box11 from "./Box11.vue";
import Box13 from "./Box13.vue";
import Box14 from "./Box14.vue";
import Box15 from "./Box15.vue";
import Box16 from "./Box16.vue";
import Box17 from "./Box17.vue";
import Box18 from "./Box18.vue";
import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";

export default {
  components: {
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Box9,
    Box10,
    Box11,
    Box13,
    Box14,
    Box15,
    Box16,
    Box17,
    Box18,
    pageRightFloat,
    Header,
    Footer,
  },
  data() {
    return {from:''};
  },
  mounted() {
   
   this.from=this.getQueryString("from")
  },
  methods: {
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    goHref() {
        this.mai("人工智能开发-AI就业课","免费领取",0,null)
      window.open("https://m.boxuegu.com/route/ai");
    },
  },
};
</script>

<style lang="scss" scoped>
.box12 {
  width: 100%;
  height: 280px;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/ai/box12.png") no-repeat;
  background-size: cover;
}

.box19 {
  position: relative;
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/ai/box19-bg.png") no-repeat;
  background-size: cover;
  .left-box {
    position: absolute;
    top: 32px;
    left: 64px;
    font-size: 40px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    .left-btn {
      margin-top: 24px;
      width: 160px;
      height: 56px;
      background: #ffffff;
      border-radius: 8px;
      text-align: center;
      font-size: 24px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #2ea5fc;
      line-height: 56px;
    }
  }

  .box19-icon {
    position: absolute;
    right: 2px;
    bottom: 18px;
    width: 336px;
    height: 224px;
  }
}
</style>
